import React, { Fragment } from 'react';
import TorontoHeading from './TorontoHeading';
import JobDetails from './JobDetails';
import WhyAutzu from './WhyAutzu';
import WhyWait from './WhyWait';
import TorontoVehicleTypes from './TorontoVehicleTypes';

const Container = () => (
  <Fragment>
    <TorontoHeading />
    <JobDetails />
    <WhyAutzu />
    <TorontoVehicleTypes landing={true} />
    <WhyWait />
  </Fragment>
);

export default Container;



// WEBPACK FOOTER //
// ./src/components/Static/UberToronto/Container.js